(() => {
  const init = () => document.querySelectorAll('[data-bib-shop]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const rows = [...root.querySelectorAll('[data-bib-row]')];
    const submit = root.querySelector('[data-bib-submit]');
    if (!submit) return;
    const message = root.querySelector('[data-bib-message]');
    const money = cents => (cents / 100).toLocaleString(document.documentElement.lang || 'en-GB', {style: 'currency', currency: root.dataset.currency});
    let busy = false;
    const quantity = row => Number(row.querySelector('[data-bib-quantity]').value) || 0;
    const update = () => {
      let count = 0, total = 0;
      rows.forEach(row => {
        const input = row.querySelector('[data-bib-quantity]');
        const max = Number(row.dataset.max);
        input.max = max;
        input.value = Math.min(max, Math.max(0, Math.floor(Number(input.value) || 0)));
        const n = quantity(row);
        count += n;
        total += n * Number(row.dataset.price);
        row.querySelector('[data-bib-step="-1"]').disabled = busy || n === 0;
        row.querySelector('[data-bib-step="1"]').disabled = busy || n >= max;
        input.disabled = busy;
      });
      root.querySelector('[data-bib-count]').textContent = count;
      root.querySelector('[data-bib-total]').textContent = money(total);
      submit.disabled = busy || count === 0;
    };
    root.addEventListener('click', event => {
      const button = event.target.closest('[data-bib-step]');
      if (!button || busy) return;
      const row = button.closest('[data-bib-row]');
      row.querySelector('[data-bib-quantity]').value = quantity(row) + Number(button.dataset.bibStep);
      message.textContent = '';
      update();
    });
    root.addEventListener('input', event => {
      if (event.target.matches('[data-bib-quantity]')) {message.textContent = ''; update();}
    });
    submit.addEventListener('click', async () => {
      if (busy) return;
      update();
      const items = rows.filter(row => quantity(row) > 0).map(row => ({id: Number(row.dataset.id), quantity: quantity(row)}));
      if (!items.length) {message.textContent = root.dataset.empty; return;}
      busy = true;
      update();
      message.textContent = root.dataset.adding;
      root.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(root.dataset.addUrl, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok) {
          if (response.status === 422) {
            message.textContent = data.description || root.dataset.error;
            busy = false;
            root.removeAttribute('aria-busy');
            update();
            return;
          }
          throw new Error('cart_response');
        }
        window.location.assign(root.dataset.cartUrl);
      } catch (error) {
        message.textContent = root.dataset.error;
        const link = document.createElement('a');
        link.href = root.dataset.cartUrl;
        link.textContent = root.dataset.viewBasket;
        message.append(link);
        submit.disabled = true;
      }
    });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
